import VueNumberFormat from "vue-number-format";

export default function (app) {
  app.use(VueNumberFormat, {
    precision: 0,
    decimal: ",",
    thousand: " ",
    prefix: "",
  });
}
